(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('feature', ["$q", "http", "$routeParams", function ($q, http, $routeParams) {
        var defaults = {
            showActiveResolver: true,
            maxRowsInPolicyForSorting: 1000,
            policyPropertiesRecursionLimit: 2
        };
        var bannerDefaultFlag = { enableSwitchToUI2Banner: false };
        var resolvers = [
            {
                'api': '/api/v1/generic/ui_features_public',
                deferred: $q.defer(),
                resolved: false,
                data: {},
                public: true
            },
            {
                'api': '/api/v1/generic/ui_features',
                deferred: $q.defer(),
                resolved: false,
                data: {}
            }
        ];
        var deferred = {
            'true': $q.defer(),
            'false': $q.defer()
        };
        function updateResult(resolver) {
            if (resolver.public) {
                if (_(resolver.data.guiVersion).isUndefined()) {
                    resolver.data.guiVersion = window.guiVersion;
                }
                if (window.guiVersion == 2) {
                    resolver.data.guiVersion = 2;
                }
                if (_(resolver.data.checkpointTheme).isUndefined()) {
                    resolver.data.checkpointTheme = false;
                }
                if (_(resolver.data.sonicwallTheme).isUndefined()) {
                    resolver.data.sonicwallTheme = false;
                }
                if (_(resolver.data.lastlineTheme).isUndefined()) {
                    resolver.data.lastlineTheme = false;
                }
                if (resolver.data.guiVersion == 1) {
                    resolver.data.checkpointTheme = false;
                    resolver.data.sonicwallTheme = false;
                    resolver.data.lastlineTheme = false;
                }
                if (!resolver.data.checkpointTheme && resolver.data.darkTheme) {
                    resolver.data.isDarkTheme = true;
                }
                if (_(resolver.data.hideSupportJIRA).isUndefined()) {
                    resolver.data.hideSupportJIRA = false;
                }
                resolver.data.avananTheme = !resolver.data.checkpointTheme && !resolver.data.sonicwallTheme && !resolver.data.lastlineTheme;
            } else {
                delete resolver.data.checkpointTheme;
                delete resolver.data.sonicwallTheme;
                delete resolver.data.lastlineTheme;
                delete resolver.data.guiVersion;
                delete resolver.data.hideSupportJIRA;
            }
            $.extend(true, result, resolver.data);
            if (result.guiVersion == 2) {
                $.extend(true, result, { guiV2: true });
            }
        }
        var initialized = false;
        var result = {
            init: function (publicOnly, wait, force) {
                if (initialized && !force) {
                    return $q.when();
                }
                if (_(publicOnly).isUndefined()) {
                    publicOnly = false;
                }
                if (wait) {
                    return deferred[publicOnly].promise;
                }
                return $q.all(_(resolvers).map(function (resolver) {
                    if (publicOnly && !resolver.public) {
                        return $q.when(null);
                    }
                    if (resolver.resolved) {
                        return resolver.deferred.promise;
                    }
                    return http.get(resolver.api).then(function (response) {
                        resolver.data = response.data;
                        updateResult(resolver);
                        resolver.deferred.resolve(response);
                        resolver.resolved = true;
                    }, function (err) {
                        console.log('Can not get feature data', err);
                        if (err) {
                            err.data = { guiVersion: 2 };
                        }
                        resolver.data = { guiVersion: 2 };
                        updateResult(resolver);
                        resolver.deferred.resolve(err);
                        resolver.resolved = false;
                    });
                })).then(function (result) {
                    deferred[publicOnly].resolve(result);
                    if (!publicOnly) {
                        deferred[true].resolve(result);
                        initialized = true;
                    }
                    return result;
                }, function (err) {
                    deferred[publicOnly].resolve(err);
                    if (!publicOnly) {
                        deferred[true].resolve(err);
                    }
                    return err;
                });
            },
            isShowAnomalyTable: function () {
                return result.showAnomalyTable && _([
                    'shadow-it',
                    'google_drive'
                ]).contains($routeParams.module);
            }
        };
        $.extend(result, defaults);
        result = $.extend({}, bannerDefaultFlag, result);
        return result;
    }]);
}());